import EarningStats from "../earningStats";
import PlansAccountsInFigure from "../plansAccountsinFigure";
import styles from "./style.module.scss";

function AnalyticsPlanGrid() {
  return (
    <div className={styles.mainContainer}>
      <EarningStats />
      <PlansAccountsInFigure />
    </div>
  );
}

export default AnalyticsPlanGrid;
